(() => {
  document.querySelectorAll('[data-be-directory]').forEach(directory => {
    if (directory.dataset.beAnchorsReady) return;
    directory.dataset.beAnchorsReady = 'true';
    let frame = 0;
    directory.addEventListener('click', event => {
      const trigger = event.target.closest('.in-page-link[data-target]');
      if (!trigger || !directory.contains(trigger)) return;
      const target = document.getElementById(trigger.dataset.target.slice(1));
      if (!target || !directory.contains(target)) return;
      event.preventDefault();
      cancelAnimationFrame(frame);
      const start = window.scrollY;
      const started = performance.now();
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const step = now => {
        const progress = reduce ? 1 : Math.min(1, (now - started) / 550);
        const margin = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
        // Re-read the destination while the header changes its in-flow height.
        const destination = window.scrollY + target.getBoundingClientRect().top - margin;
        const eased = 1 - Math.pow(1 - progress, 3);
        window.scrollTo({top: start + (destination - start) * eased, behavior: 'instant'});
        if (progress < 1) frame = requestAnimationFrame(step);
        else frame = requestAnimationFrame(() => {
          target.scrollIntoView({block:'start', behavior:'instant'});
        });
      };
      frame = requestAnimationFrame(step);
    });
  });
})();
